import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import moment from 'moment';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import CurrentAppEnterprisePlan from '@/plugins/graphql/queries/current-app-enterprise-plan.gql';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import BaseOverlayLoader from '@/components/v2/BaseOverlayLoader';
import PageTitle from '@/components/v2/PageTitle.vue';
import ActionButton from '@/components/action_button/Index.vue';
import ButtonLoaderMixin from '@/helpers/vue_mixins/ButtonLoaderMixin';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import PlanSubscription from '@/plugins/graphql/mutations/v2/msme-extend.gql';
let MsmeExtended = class MsmeExtended extends Mixins(ViewportSizeMixin, RouterParamsAppMixin, AlertMixin, ButtonLoaderMixin) {
    constructor() {
        super(...arguments);
        this.appEnterprisePlanUuid = null;
    }
    onExtend() {
        const input = { appEnterprisePlanUuid: this.appEnterprisePlanUuid };
        this.requestOnFlight();
        this.$apollo
            .mutate({
            mutation: PlanSubscription,
            variables: { input },
        })
            .then(() => {
            this.requestDone();
            this.successNotification('MSME Subscription extended!');
            this.$router.push({ name: 'enterprise-plans' });
        })
            .catch((e) => {
            this.requestDone();
            this.errorNotification(e.message);
        });
    }
    onExtendLater() {
        this.$router.push(`/apps/${this.bundleKey}/${this.appUUID}/overview`);
    }
};
MsmeExtended = __decorate([
    Component({
        components: {
            BaseOverlayLoader,
            ActionButton,
            PageTitle,
        },
        apollo: {
            appEnterprisePlanUuid: {
                query: CurrentAppEnterprisePlan,
                variables() {
                    return { appUUID: this.appUUID };
                },
                update({ app: { currentAppEnterprisePlan } }) {
                    let { msmeEndAt, msmeStartAt } = currentAppEnterprisePlan;
                    const { eligibleMsmeExtension } = currentAppEnterprisePlan;
                    // parse durations
                    msmeEndAt = moment(msmeEndAt);
                    msmeStartAt = moment(msmeStartAt);
                    if (!currentAppEnterprisePlan.enterprisePlan.accelerator) {
                        this.errorNotification('Plan currently not subscribed in MSME');
                        this.$router.push({ name: 'billing' });
                    }
                    else if (!moment().isBetween(msmeStartAt, msmeEndAt)) {
                        this.errorNotification('MSME Extension Already expired.');
                        this.$router.push({ name: 'billing' });
                    }
                    else if (!eligibleMsmeExtension) {
                        this.errorNotification('Your In-App Store is not eligible for MSME extension');
                        this.$router.push({ name: 'billing' });
                    }
                    return currentAppEnterprisePlan.uuid;
                },
            },
        },
    })
], MsmeExtended);
export default MsmeExtended;
